// TransactionsTabs.jsx
const TABS = [
  { key: "in", label: "Входящие Платежи" },
  { key: "out", label: "Исходящие Платежи" },
];

export default function TransactionsTabs({ tab, onTabChange }) {
  return (
    <div
      className="
        mt-4 bg-[#F2F5FB] rounded-[16px] p-2
        flex flex-col gap-2
        [@media(min-width:900px)]:flex-row
        [@media(min-width:900px)]:flex-nowrap
      "
    >
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onTabChange(t.key)}
          className={`h-[44px] w-full rounded-[14px] font-semibold transition-colors
            [@media(min-width:900px)]:w-[250px]
            ${
              tab === t.key
                ? "bg-white border border-[var(--blue-3)] text-[var(--blue-3)]"
                : "text-[#6B7280]"
            }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}